import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from "@mui/material";
import { useFetcher, useNavigate } from "react-router-dom";
import { useDecoratedFetcher } from "../page-labels/useFetcherWithSnackbar";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";

export function NewScriptDialog(props: { lensId: number; close: () => void }) {
  const { lensId, close } = props;
  const upsertFetcher = useFetcher();
  const upsertFetcherResponse = useDecoratedFetcher(upsertFetcher);
  const [scriptName, setScriptName] = useState("");
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const save = async () => {
    upsertFetcher.submit(
      {
        intent: "upsert",
        lensId,
        scriptName,
        scriptContent: "",
        requiredFieldFindings: [],
        flags: [],
        defaultParameters: [],
      },
      {
        encType: "application/json",
        method: "POST",
        action: `/lens-editor/${lensId}/scripts`,
      }
    );
  };

  useEffect(() => {
    if (upsertFetcherResponse.completed) {
      navigate(`./${scriptName}`);
      close();
    }
  }, [upsertFetcherResponse.completed]);

  useEffect(() => {
    if (upsertFetcherResponse.completed) {
      enqueueSnackbar("Script saved", { variant: "success" });
    }
  }, [upsertFetcherResponse.completed]);

  return (
    <Dialog open={true} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>New Script</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <TextField
            value={scriptName}
            onChange={(evt) => {
              const name = evt.target.value as string;
              setScriptName(name.toLowerCase().replace(/\s/g, ""));
            }}
            label="Name"
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Cancel</Button>
        <Button disabled={!scriptName.length} onClick={save} variant="contained">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
